module.exports = __webpack_public_path__ + "img/Qdiamante.6940967d.png";